import { KeyValueScope } from '../message/types';
export var LOGGER_NAME = 'Mdg2Client';
export var DEFAULT_QUALITY = 'BST';
export var APP_SCOPE = {
    id_application: KeyValueScope.FROM_HEADER,
    id_user: KeyValueScope.NONE,
    id_group: KeyValueScope.NONE
};
export var USER_SCOPE = {
    id_application: KeyValueScope.FROM_HEADER,
    id_user: KeyValueScope.FROM_HEADER,
    id_group: KeyValueScope.NONE
};
//# sourceMappingURL=constants.js.map